import { GridFilterModel } from "@mui/x-data-grid";
import { SortingModel } from "../../models/shared/SortingModel";
import { api_url } from "../../utils/ApiContext";
import { appendStringFilterToUri } from "../../utils/filtering";
import {
  FetchPaginatedApiModel,
  WithData,
  WithRecordID,
} from "../../models/shared/CommonModels";
import {
  postRequest,
  putRequest,
  deleteRequest,
  getRequest,
} from "../apiCommon";
import { BeneMaterialeModel } from "../../models/api/response/bene/BeneMaterialeModel";

const TAKE_LIMIT = 15;

const setQueryParameters = (
  filter: GridFilterModel | undefined,
  sort: SortingModel
) => {
  let uri = api_url.concat("/api/materialebene?");

  filter?.items.forEach((item) => {
    uri = appendStringFilterToUri(item.field, "nome", item.value, uri);
    uri = appendStringFilterToUri(item.field, "descrizione", item.value, uri);
  });

  uri = uri.concat("&sort_field=", sort.field.toString());
  uri = uri.concat("&sort_direction=", sort.direction.toString());

  uri = uri.endsWith("?") ? uri.concat("skip=") : uri.concat("&skip=");

  return uri;
};

const getMateriale = (
  selectedId: number,
  page: number,
  sort: SortingModel,
  filter?: GridFilterModel
) => {
  let uri = setQueryParameters(filter, sort);

  let skip = 0;
  let take = TAKE_LIMIT;
  if (page > 0) skip = page * take;

  return getRequest<FetchPaginatedApiModel<BeneMaterialeModel[]>>(
    uri.concat(
      "&skip=",
      skip.toString(),
      "&take=",
      take.toString(),
      "&selectedId=",
      selectedId.toString()
    )
  );
};

const createMaterialeBene = (postdata: WithData) => {
  return postRequest(api_url.concat("/api/materialebene"), postdata.data);
};

const updateMateriale = (putdata: WithRecordID) => {
  return putRequest(
    api_url.concat("/api/materialebene/", putdata.recordID.toString()),
    putdata.data
  );
};

const deleteMateriale = (id: number) => {
  return deleteRequest(api_url.concat("/api/materialebene/", id.toString()));
};

export { getMateriale, createMaterialeBene, updateMateriale, deleteMateriale };
